import styled from 'styled-components';

const MAX_HEIGHT = 500;
const SPACING = 10;

const AttachmentSliderContainer = styled.div`
  width: 100%;
  margin: ${SPACING}px 0;

  .slick-track {
    min-width: 100%;
    display: flex;
    align-items: center;

    & .slick-slide {
      max-height: ${MAX_HEIGHT}px;
      display: flex;
      justify-content: center;
    }
  }
`;

const AttachmentCard = styled.div`
  max-height: ${MAX_HEIGHT}px;
  align-items: center;
  margin: 0;
  padding: 0 ${SPACING}px;
`;

export {
  AttachmentSliderContainer,
  AttachmentCard,
};
